module.exports = __webpack_public_path__ + "static/img/aa-3.55adec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-3.png
// module id = 1ozT
// module chunks = 1